//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p class="some-text">Добро пожаловать, {{activeUser.Name}}!</p>

    <Row>
      <Col span="8">
        <cms-info-panel-widget>
        </cms-info-panel-widget>
      </Col>
    </Row>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

// import NewsWidget from './NewsWidget.vue'
// import FinixTasksWidget from './FinixTasksWidget.vue'
import CmsInfoPanelWidget from './CMSInfoPanelWidget.vue'

export default {
  // components: { NewsWidget, FinixTasksWidget },
  components: { CmsInfoPanelWidget },
  computed: {
    ...mapGetters([
      'activeUser'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 50px 0px;
  padding: 20px;
  /*overflow: hidden;*/
  background: #D9E0E7;
}
.some-text {
  font-family: "Roboto Light", sans-serif;
  font-size: 15px;
  padding: 0px 0px 20px 20px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainDashboard.vue?7bfe2f8b